import { useState } from "react";
import Popup from "../Modal/Popup";
import { TabContent } from "reactstrap";
import { Tabs } from "./Tabs";
import { TabPages } from "./TabPages";
import { TabFeatures } from "./TabFeatures";
import { TabStyles } from "./TabStyles";
import { TabPresetStyles } from "./TabPresetStyles";
import "./Navbar.scss";

const NavigationModal = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  return (
    <Popup
      width="700"
      header="Navigation Header Settings"
      closePopup={props.hideSettings}
      close={props.hideSettings}
    >
      <div className="navigationSettingsWrapper">
        <div className="navigationModal">
          <div className="popup-middle--content">
            <Tabs activeTab={activeTab} onClickTab={toggle} />
            <div className="modalScrollContainer">
              <TabContent activeTab={activeTab}>
                <TabPages pageTitle={props.pageTitle} onChangeTitle={props.onChangeTitle} createNewBtn={props.createNewBtn} />
                <TabFeatures />
                <TabStyles />
                <TabPresetStyles />
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );

}
export default NavigationModal;
